(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ke-carousel"] && !Shopify.designMode) return;
  try {
    (()=>{function setup(){document.querySelectorAll('.ke-page [data-ke-carousel]').forEach(root=>{if(root.dataset.ready)return;const track=root.querySelector('[data-ke-track]'),prev=root.querySelector('[data-ke-prev]'),next=root.querySelector('[data-ke-next]');if(!track||!prev||!next)return;root.dataset.ready='1';const update=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};const move=direction=>{const card=track.firstElementChild;if(!card)return;track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});new ResizeObserver(update).observe(track);update()})}setup();document.addEventListener('shopify:section:load',setup)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klyr-scp-demo-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('klyr-demo-videos')) {
    customElements.define('klyr-demo-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.dispose) return;
        const rail = this.querySelector('.klyr-demo__rail');
        const items = [...this.querySelectorAll('.klyr-demo__item')];
        const videos = items.map(item => item.querySelector('video'));
        if (!rail || !videos.length) return;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const controller = new AbortController();
        const options = { signal: controller.signal };
        let active = 0;
        let visible = false;
        let manualPause = false;
        let frame = 0;

        const progress = () => {
          const video = videos[active];
          const fraction = Number.isFinite(video.duration) && video.duration > 0
            ? video.currentTime / video.duration
            : 0;
          items[active].querySelector('.klyr-demo__progress > span').style.transform = 'scaleX(' + fraction + ')';
          if (!video.paused) frame = requestAnimationFrame(progress);
        };

        const reveal = () => {
          const box = items[active].getBoundingClientRect();
          const bounds = rail.getBoundingClientRect();
          if (box.left < bounds.left || box.right > bounds.right) {
            rail.scrollTo({
              left: rail.scrollLeft + box.left - bounds.left,
              behavior: reduced.matches ? 'auto' : 'smooth'
            });
          }
        };

        const sync = () => {
          videos.forEach((video, index) => {
            if (index !== active) video.pause();
          });
          const video = videos[active];
          if (!visible || document.hidden || manualPause || reduced.matches) {
            video.pause();
            return;
          }
          reveal();
          video.play().catch(() => {});
        };

        const select = index => {
          videos[active].pause();
          active = index;
          manualPause = false;
          items.forEach((item, position) => item.classList.toggle('is-active', position === active));
          videos[active].currentTime = 0;
          progress();
          sync();
        };

        items.forEach((item, index) => {
          const video = videos[index];
          video.muted = true;
          video.playsInline = true;
          const showPoster = () => item.classList.remove('is-playing');
          showPoster();
          video.addEventListener('playing', () => {
            if (index !== active || video.paused || video.ended) return;
            item.classList.add('is-playing');
            cancelAnimationFrame(frame);
            progress();
          }, options);
          ['pause', 'ended', 'waiting', 'emptied', 'error', 'loadstart'].forEach(eventName => {
            video.addEventListener(eventName, showPoster, options);
          });
          video.addEventListener('pause', () => {
            if (index === active) {
              cancelAnimationFrame(frame);
              progress();
            }
          }, options);
          video.addEventListener('ended', () => select((index + 1) % videos.length), options);

          const activate = () => {
            if (index !== active) {
              select(index);
              if (reduced.matches) video.play().catch(() => {});
            } else {
              manualPause = !video.paused;
              if (manualPause) video.pause();
              else video.play().catch(() => {});
            }
          };

          item.addEventListener('click', activate, options);
          item.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              activate();
            }
          }, options);
        });

        items.forEach((item, index) => item.classList.toggle('is-active', index === 0));
        const observer = new IntersectionObserver(entries => {
          visible = entries[0].intersectionRatio >= 0.6;
          sync();
        }, { threshold: [0, 0.6] });
        observer.observe(rail);
        document.addEventListener('visibilitychange', sync, options);
        reduced.addEventListener('change', sync, options);

        this.dispose = () => {
          controller.abort();
          observer.disconnect();
          cancelAnimationFrame(frame);
          videos.forEach((video, index) => {
            video.pause();
            items[index].classList.remove('is-playing');
          });
        };
      }

      disconnectedCallback() {
        if (this.dispose) {
          this.dispose();
          this.dispose = null;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["skin-corrector-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('skin-corrector-offer')) {
    customElements.define('skin-corrector-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const config = this.querySelector('[data-config]');
        if (!config) return;
        this.initialized = true;
        this.config = JSON.parse(config.textContent);
        const hairDialog = this.querySelector('[data-hair-dialog]');
        this.querySelector('[data-hair-guide]')?.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); hairDialog.showModal(); });
        this.querySelector('[data-close-guide]')?.addEventListener('click', () => hairDialog.close());
        hairDialog?.addEventListener('click', event => { if (event.target === hairDialog) hairDialog.close(); });
        this.querySelectorAll('[data-guide-variant]').forEach(button => {
          const source = this.querySelector(`[data-shade][value="${button.dataset.guideVariant}"]`)?.nextElementSibling;
          const swatch = button.querySelector('[data-guide-swatch]');
          if (source && swatch) swatch.style.cssText = source.style.cssText;
          button.addEventListener('click', () => {
            this.guideVariant = button.dataset.guideVariant;
            this.querySelectorAll('[data-guide-variant]').forEach(option => {
              const selected = option === button;
              option.setAttribute('aria-pressed', String(selected));
              option.querySelector('.mb-quiz-radio').classList.toggle('mb-quiz-radio--on', selected);
            });
            this.querySelector('[data-guide-match]').textContent = button.querySelector('.mb-quiz-name').textContent;
            this.querySelector('[data-guide-result]').hidden = false;
          });
        });
        this.querySelector('[data-confirm-guide]')?.addEventListener('click', () => {
          const input = this.querySelector(`[data-shade][value="${this.guideVariant}"]`);
          if (input && !input.disabled) { input.checked = true; input.dispatchEvent(new Event('change')); hairDialog.close(); }
        });
        this.qty = 4;
        this.once = false;
        this.busy = false;
        const requested = new URL(location.href).searchParams.get('variant');
        this.variant = this.config.variants.find(v => String(v.id) === requested && v.available) || this.config.variants.find(v => v.title === 'Light' && v.available) || this.config.variants.find(v => v.available) || this.config.variants[0];
        this.querySelectorAll('[data-shade]').forEach(input => {
          input.checked = String(this.variant.id) === input.value;
          input.addEventListener('change', () => { this.variant = this.config.variants.find(v => String(v.id) === input.value); this.update(); this.syncGallery(); });
        });
        this.querySelectorAll('[data-bundle]').forEach(input => input.addEventListener('change', () => { this.qty = Number(input.value); this.update(); }));
        this.querySelector('[data-subscribe]').addEventListener('change', event => { this.once = !event.target.checked; this.update(); });
        this.querySelector('[data-form]').addEventListener('submit', event => { event.preventDefault(); this.addToCart(); });
        this.querySelector('[data-sticky-button]').addEventListener('click', () => this.querySelector('.scp-atc').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'}));
        this.observer = new IntersectionObserver(entries => { const e = entries[0]; this.querySelector('[data-sticky]').hidden = e.isIntersecting || e.boundingClientRect.top >= 0; });
        this.observer.observe(this.querySelector('.scp-atc'));
        this.birthdayListener = () => this.update();
        document.addEventListener('klyr:birthday', this.birthdayListener);
        this.update();
        if (this.config.upsellHandle) {
          fetch(`${window.Shopify?.routes?.root || '/'}products/${this.config.upsellHandle}?section_id=custom-quickview-product`)
            .then(r => r.text()).then(html => { this.upsellHtml = html; }).catch(() => {});
        }
      }
      syncGallery() {
        const url = new URL(location.href);
        url.searchParams.set('variant', this.variant.id);
        history.replaceState({}, '', url);
        const slider = this.closest('.shopify-section')?.querySelector('.single-product-slider');
        const images = Array.from(slider?.querySelectorAll('.swiper-slide img[data-image-id]') || []);
        const index = images.findIndex(image => image.dataset.imageId === String(this.variant.mediaId));
        if (index >= 0 && slider?.swiper) slider.swiper.slideTo(index);
      }
      disconnectedCallback() { this.observer?.disconnect(); document.removeEventListener('klyr:birthday', this.birthdayListener); this.initialized = false; }
      update() {
        const t = this.config.text;
        const qty = this.qty;
        const pricing = this.config.pricing;
        const kind = this.once ? 'once' : 'sub';
        const tier = pricing.tiers[qty][kind];
        const birthday = window.KlyrBirthday;
        const birthdayPrice = birthday?.hasPrice(this.once);
        const reduced = cents => cents - Math.floor(cents * 0.25);
        const displayTotal = birthdayPrice ? reduced(tier.total) : tier.total;
        this.total = displayTotal;
        const subTier = pricing.tiers[qty].sub;
        const subBirthday = birthday?.hasPrice(false);
        const subUnit = subBirthday ? reduced(subTier.total) / qty : subTier.unit;
        const subSaved = subBirthday ? Math.round((pricing.strike - subUnit) / pricing.strike * 1000) / 10 : Math.round((pricing.strike - subUnit) / pricing.strike * 100);
        const subscriptionTitle = t.subscriptionSavings.replace('__AMOUNT__', subSaved.toLocaleString(document.documentElement.lang || 'en') + '%');
        this.querySelector('[data-subscribe-title]').textContent = subscriptionTitle;
        this.querySelector('[data-subscribe]').setAttribute('aria-label', subscriptionTitle);
        this.querySelector('[data-shade-name]').textContent = this.variant.title;
        this.querySelectorAll('[data-gift]').forEach(gift => {
          const locked = qty < Number(gift.dataset.minimum);
          gift.classList.toggle('is-locked', locked);
          gift.querySelector('[data-gift-state]').textContent = locked ? t.locked : t.unlocked;
        });
        this.querySelectorAll('[data-card]').forEach(card => {
          const count = Number(card.dataset.card);
          const cardTier = pricing.tiers[count][kind];
          const unit = birthdayPrice ? reduced(cardTier.total) / count : cardTier.unit;
          card.querySelector('[data-unit]').textContent = birthdayPrice ? birthday.money(unit, pricing.currency) : cardTier.unitText;
          card.classList.toggle('scp-card--birthday', Boolean(birthdayPrice));
          const badge = card.querySelector('[data-saving]');
          if (badge) {
            const saved = birthdayPrice ? Math.round((pricing.strike - unit) / pricing.strike * 1000) / 10 : Math.round((pricing.strike - unit) / pricing.strike * 100);
            badge.textContent = t.savePercent.replace('__PERCENT__', saved);
          }
        });
        this.querySelector('[data-recurring]').textContent = this.once ? t.onceTerms : t['recurring'+qty];
        this.querySelector('[data-atc-price]').textContent = birthdayPrice ? birthday.money(displayTotal, pricing.currency) : tier.totalText;
        const birthdayNote = this.querySelector('[data-birthday-price-note]');
        if (birthdayNote) { birthdayNote.hidden = !birthdayPrice; birthdayNote.textContent = this.once ? birthday.text.with_code : birthday.text.first_order; }
        this.querySelector('.scp-atc').disabled = !this.variant.available || this.busy;
        this.querySelector('.scp-atc').setAttribute('aria-busy', String(this.busy));
        this.querySelector('[data-atc-label]').textContent = t.add;
        this.querySelector('[data-status]').hidden = true;
        this.querySelector('[data-sticky-label]').textContent = t.add;
      }
      status(message) { const status = this.querySelector('[data-status]'); status.textContent = message; status.hidden = false; }
      async addToCart() {
        const plans = this.config.plans;
        if (!plans) { this.status(this.config.text.preview); return; }
        if (this.busy) return;
        const motion = window.KlyrButtonMotion?.begin(this.querySelector('.scp-atc'));
        this.busy = true;
        this.update();
        let failed = false;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const json = { 'Content-Type': 'application/json' };
          const item = { id: this.variant.id, quantity: this.qty };
          if (!this.once) item.selling_plan = plans[this.qty];
          const showUpsell = this.qty < 4 && this.config.upsellHandle && document.querySelector('custom-quickview-popup');
          const cartAfter = await window.KlyrCart.add([item], { open: false, productId: this.config.productId });
          await motion?.success();
          if (showUpsell) await this.openUpsell(root, cartAfter);
          else document.querySelector('cart-drawer-component')?.open();
        } catch (error) {
          console.error(error);
          failed = error.message || this.config.text.cartError;
        } finally {
          motion?.reset();
          this.busy = false;
          this.update();
          if (failed) this.status(failed);
        }
      }
      // Post add-to-cart upsell (same sidebar as the old bundle): the sponges follow the delivery interval of the bottles.
      async openUpsell(root, cart) {
        const popup = document.querySelector('custom-quickview-popup');
        try {
          const html = this.upsellHtml || await fetch(`${root}products/${this.config.upsellHandle}?section_id=custom-quickview-product`).then(r => r.text());
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          const section = tmp.querySelector('#shopify-section-custom-quickview-product');
          const content = popup.querySelector('.quickview-sidebar__content');
          if (!section || !content) throw new Error('Upsell markup missing');
          content.innerHTML = section.innerHTML;
          const qv = content.querySelector('custom-quickview-product');
          if (qv) {
            const plan = !this.once && window.klyrSpongePlan ? await window.klyrSpongePlan(this.qty >= 2 ? 2 : 1) : null;
            if (plan) qv.dataset.sellingPlan = plan;
            else delete qv.dataset.sellingPlan;

          }
          await popup.openDrawer(cart);
        } catch (error) {
          console.error('Upsell sidebar failed:', error);
          setTimeout(() => document.querySelector('cart-drawer-component')?.open(), 100);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
